import React from 'react';

export const AddMediaSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="79"
    height="69"
    viewBox="0 0 79 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5888 42.3661C17.738 42.3661 20.2983 39.8053 20.2983 36.6562C20.2983 33.5072 17.738 30.9463 14.5888 30.9463C11.4399 30.9463 8.87891 33.5072 8.87891 36.6562C8.87891 39.8053 11.4399 42.3661 14.5888 42.3661Z"
      fill="currentColor"
    />
    <path
      d="M50.2747 22.3818H7.45145C3.51784 22.3818 0.314453 25.5852 0.314453 29.5194V60.9227C0.314453 64.8568 3.51784 68.0603 7.45145 68.0603H50.2747C54.2088 68.0603 57.4123 64.8568 57.4123 60.9227V29.5194C57.4123 25.5852 54.2088 22.3818 50.2747 22.3818ZM7.45145 28.0918H50.2747C51.0631 28.0918 51.7024 28.7311 51.7024 29.5194V49.7862L42.6839 39.2628C41.7273 38.141 40.3425 37.5414 38.8553 37.5074C37.3766 37.5158 35.9892 38.1723 35.0414 39.3088L24.4381 52.0356L20.9837 48.5896C19.0313 46.6372 15.8536 46.6372 13.9038 48.5896L6.02435 56.4663V29.5194C6.02435 28.7311 6.66367 28.0918 7.45145 28.0918Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.6948 28.5489C60.6948 30.0964 61.9493 31.3508 63.4967 31.3508C65.0442 31.3508 66.2986 30.0964 66.2986 28.5489V18.8122H76.0343C77.5817 18.8122 78.8362 17.5578 78.8362 16.0103C78.8362 14.4629 77.5817 13.2084 76.0343 13.2084H66.2986V3.4728C66.2986 1.92535 65.0442 0.670898 63.4967 0.670898C61.9493 0.670898 60.6948 1.92535 60.6948 3.4728V13.2084H50.9581C49.4107 13.2084 48.1562 14.4629 48.1562 16.0103C48.1562 17.5578 49.4107 18.8122 50.9581 18.8122H60.6948V28.5489Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.2669 33.5447V41.2215V52.3583C60.2669 53.1466 59.6275 53.7859 58.8391 53.7859H58.6115V59.4956H58.8391C62.2815 59.4956 65.1645 57.043 65.8314 53.7942C65.9208 53.3591 65.9704 52.9097 65.9762 52.4501C65.9766 52.4194 65.9768 52.3887 65.9768 52.358V33.9569C65.2218 34.3037 64.3818 34.4971 63.4966 34.4971C62.3059 34.4971 61.1969 34.1472 60.2669 33.5447ZM49.2137 13.8174H58.8391C62.2814 13.8174 65.1644 16.2699 65.8314 19.5185C65.9267 19.9826 65.9768 20.4629 65.9768 20.9547V29.8537C65.5075 30.7439 64.5729 31.3507 63.4966 31.3507C61.9492 31.3507 60.6947 30.0963 60.6947 28.5488V18.8121H50.958C49.4106 18.8121 48.1561 17.5577 48.1561 16.0102C48.1561 15.1222 48.5692 14.3307 49.2137 13.8174ZM45.427 13.8174C45.1578 14.4959 45.0098 15.2358 45.0098 16.0102C45.0098 17.326 45.437 18.542 46.1603 19.5271H16.0159C15.2281 19.5271 14.5888 20.1664 14.5888 20.9547V21.4902H8.87891V20.955C8.87891 20.5277 8.9167 20.1087 8.98912 19.7017C9.58356 16.3626 12.5097 13.8174 16.0159 13.8174H45.427Z"
      fill="currentColor"
    />
  </svg>
);

export default AddMediaSvg;
